import Vue from 'vue'
import AscElementResizeDetector from './AscElementResizeDetector'

Vue.directive('el-resize', AscElementResizeDetector)
